import type { SortKey, SortOrder } from '../../state/filtersSlice';

export interface StoresQuery {
  sort: SortKey;
  order: SortOrder;
  regions: string[];
  cities: string[];
  focusSearch: boolean;
}

const list = (v: string | null): string[] =>
  v ? v.split(',').map((s) => s.trim()).filter(Boolean) : [];

/** Parses /app/stores?sort=&order=&region=&city=&focus=search with safe defaults. */
export function parseStoresQuery(search: string): StoresQuery {
  const p = new URLSearchParams(search);
  const sort = p.get('sort');
  const order = p.get('order');
  return {
    sort: sort === 'yoy' ? 'yoy' : 'sales',
    order: order === 'asc' ? 'asc' : 'desc',
    regions: list(p.get('region')),
    cities: list(p.get('city')),
    focusSearch: p.get('focus') === 'search',
  };
}

export const FILTERED_STORES_PATH = '/app/state-stores';

/**
 * Builds the link used by the State Wise rows. Deliberately NOT under /app/stores: Ionic remembers each tab's
 * last URL, so a filtered list there would come back when the Stores tab is tapped.
 */
export function storesLink(opts: { region?: string; city?: string }): string {
  const p = new URLSearchParams();
  if (opts.city) p.set('city', opts.city);
  if (opts.region) p.set('region', opts.region);
  const qs = p.toString();
  return `${FILTERED_STORES_PATH}${qs ? `?${qs}` : ''}`;
}
